import React from "react";
import PublicationsList from "../components/PublicationsList";
import "../styling/Publications.css";
import { HelpTip } from "../components/Tooltip";

export default function ExcludedPublicationsPage() {
	const description = `Publications screened as potential precision oncology cases but not included
		in ProCare because they did not fulfill the eligibility criteria following data extraction. 
		Key criteria included a clearly described treatment decision guided by a molecular biomarker and 
		sufficiently detailed information on the patient and treatment outcomes.`;

	return (
		<main className="excluded-publications-page">
			<div className="excluded-publications-header">
				<h1>Excluded publications <HelpTip text={description} /></h1>
			</div>

			<PublicationsList
				listEndpoint="/api/manuscripts/excluded/summary"
				detailEndpoint={(id) => `/api/manuscripts/excluded/${id}`}
				enableBackendFiltering={false}
				hideEmptyDetailFields
				showDownloadButton={false}
			/>
		</main>
	);
}